import issueFieldsVisibility from './issueFieldsVisibility';

export default {
  isVisible(field, options) {
    return issueFieldsVisibility[field](options);
  },
};
